import { useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import Loading from "../../components/shared/Loading";
import { useEffect, useRef, useState } from "react";
import useUser from "../../components/helpers/useUser";
import apiClient from "../../components/utils/apiClient";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import InputField from "../../components/shared/InputField";
import NormalButton from "../../components/shared/NormalButton";
import Toast from "../../components/shared/Toast";
import { getDownloadURL, getStorage, ref, uploadBytesResumable } from "firebase/storage";
import moment from "moment";
import { getApp, getApps, initializeApp } from "firebase/app";
import { firebaseConfig } from "../../components/utils/constants";
import SingleImageCompress from "../../components/helpers/SingleImageCompress";
import { useTranslation } from "react-i18next";

const Profile = () => {
    const { t } = useTranslation();
    useDocumentTitle(t('profile.pageTitle'));
    const navigate = useNavigate();
    const pageTitle = { title: t('profile.pageTitle') };

    const [isLoading, setIsLoading] = useState(true);
    const [vendor, setVendor] = useState(null);
    const [user,setUser] = useUser();
    const [vendorForm, setVendorForm] = useState(null);
    const [errors, setErrors] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:''});
    const [compressedImage, setCompressedImage] = useState(null);
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [isFormDisabled, setIsFormDisabled] = useState(false);

    const convertArabicNumbersToEnglish = string =>
  // eslint-disable-next-line no-bitwise
  string?.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => c.charCodeAt(0) & 0xf);

    const getUserData = async () => {
      try {
        const response = await apiClient.get(`vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
          setIsLoading(false);
          setVendorForm({
            name: response?.data?.name,
            contactNumber: response?.data?.contactNumber,
            email: response?.data?.email,
            taxId: response?.data?.taxId,
            bankAccountDetails: response?.data?.bankAccountDetails,
            taxDocumentUrl: response?.data?.taxDocumentUrl,
          })
        } else {
            setIsLoading(false);
        }
      } catch(err) {setIsLoading(false);}
    }

    const PatchVendor = async (url=false) => {
        setIsLoading(true);
        const finalVendorForm = {...vendorForm};
        finalVendorForm.contactNumber = convertArabicNumbersToEnglish(finalVendorForm.contactNumber);
        finalVendorForm.taxId = convertArabicNumbersToEnglish(finalVendorForm.taxId);
        if(url) {
            finalVendorForm.taxDocumentUrl = url;
        }
        try {
            const response = await apiClient.patch(`/vendors/${vendor?._id}`,Object.fromEntries(Object.entries(finalVendorForm).filter(([_, v]) => v !== '')));
            if(response?.data) {
                getUserData();
                setToast({show:true,type:'success',message:t('profile.updateSuccess')});
            } else {
                setIsLoading(false);
            }
        } catch(err) {setIsLoading(false);}
    }

    const handleClickTryUpdateVendor = () => {
        setIsLoading(true);
        if(uploadedFile && !uploadedFileUrl) {
            handlUploadAction();
        } else if (uploadedFileUrl) {
            PatchVendor(uploadedFileUrl);
        } else {
            PatchVendor();
        }
    }
    

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    const fileRef = useRef();

    const ResetInputFile = () => {
        if(fileRef.current) {
            fileRef.current.value = '';
        }

    }

    const handleChangeUpload = (e) => {
        setUploadedFile(e.target.files[0]);
        ResetInputFile();
    }


    function handlUploadAction() {
        setIsLoading(true);
        if(uploadedFile?.type.includes('image')) {
            SingleImageCompress(uploadedFile).then(compressedFile=>setCompressedImage(compressedFile));
        } else {
            setCompressedImage(uploadedFile);
        }
    }


    useEffect(()=>{

        if(compressedImage) {
            const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
            const storage = getStorage(app);
            const file = compressedImage;
            const time = Date.parse(moment().locale('en').format('YYYY-MM-DD HH:mm:ss')) / 1000;
            const storageRef = ref(storage,'VendorCommercialRecordUrl/'+time);
            const uploadTask = uploadBytesResumable(storageRef, file);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                (error) => {
                    setIsLoading(false);
                    setCompressedImage(null)
                    setToast({show:true,type:'error',message:t('profile.uploadError')});
                },
                () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadedURL) => {
                    PatchVendor(downloadedURL);
                    setUploadedFileUrl(downloadedURL);
                });
                }
            );
        }

    },[compressedImage])


    useEffect(()=>{
        if(!uploadedFile) {
            ResetInputFile();
        }
    },[uploadedFile])

    useEffect(()=>{
        if(vendorForm?.name && vendorForm?.contactNumber && vendorForm?.email && vendorForm?.taxId && vendorForm?.bankAccountDetails?.accountHolderName && vendorForm?.bankAccountDetails?.IBAN && (uploadedFile || vendorForm?.taxDocumentUrl)) {
            setIsFormDisabled(false);
        } else {
            setIsFormDisabled(true);
        }

    },[vendorForm,uploadedFile])


    return (
        <div>
            <PageHeader pageTitle={pageTitle} />
            <PageMain>
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <MainContent>

                    <NormalFormContainer heading={t('profile.formHeading')} label={t('profile.formLabel')}>

                        <div className="mb-[15px]">
                            <InputField isRequird label={t('profile.nameLabel')} placeholder={t('profile.namePlaceholder')} value={vendorForm?.name} error={errors?.name} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setVendorForm({ ...vendorForm, name: e.target.value }); hideError('name')}} />
                        </div>

                        <div className="mb-[15px]">
                            <InputField isRequird label={t('profile.contactNumberLabel')} placeholder={t('profile.contactNumberPlaceholder')} value={vendorForm?.contactNumber} error={errors?.contactNumber} errorMessage={errors?.contactNumber} translateError={true} onChange={(e)=>{setVendorForm({ ...vendorForm, contactNumber: e.target.value }); hideError('contactNumber')}} />
                        </div>

                        <div className="mb-[15px]">
                            <InputField isRequird label={t('profile.emailLabel')} placeholder={t('profile.emailPlaceholder')} value={vendorForm?.email} error={errors?.email} errorMessage={errors?.email} translateError={true} onChange={(e)=>{setVendorForm({ ...vendorForm, email: e.target.value }); hideError('email')}} />
                        </div>

                        <div className="mb-[15px]">
                            <InputField isRequird label={t('profile.bankAccountHolderLabel')} placeholder={t('profile.bankAccountHolderPlaceholder')} value={vendorForm?.bankAccountDetails?.accountHolderName} error={errors?.accountHolderName} errorMessage={errors?.accountHolderName} translateError={true} onChange={(e)=>{setVendorForm({ ...vendorForm, bankAccountDetails: {...vendorForm.bankAccountDetails, accountHolderName : e.target.value} }); hideError('accountHolderName')}} />
                        </div>

                        <div className="mb-[15px]">
                            <InputField isRequird label={t('profile.ibanLabel')} placeholder={t('profile.ibanPlaceholder')} value={vendorForm?.bankAccountDetails?.IBAN} error={errors?.IBAN} errorMessage={errors?.IBAN} translateError={true} onChange={(e)=>{setVendorForm({ ...vendorForm, bankAccountDetails: {...vendorForm.bankAccountDetails, IBAN : e.target.value} }); hideError('IBAN')}} />
                        </div>

                        <div className="mb-[15px]">
                            <InputField isRequird label={t('profile.taxIdLabel')} placeholder={t('profile.taxIdPlaceholder')} value={vendorForm?.taxId} error={errors?.taxId} errorMessage={errors?.taxId} translateError={true} onChange={(e)=>{setVendorForm({ ...vendorForm, taxId: e.target.value }); hideError('taxId')}} />
                        </div>

                        {vendorForm?.taxDocumentUrl ?
                        <div className="underline cursor-pointer select-none" onClick={()=>window.open(vendorForm?.taxDocumentUrl,'_blank')}>
                            {t('profile.viewTaxDocument')}
                        </div>
                        :<div>
                            <label htmlFor={'taxDocumentUrl'} className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">{t('profile.taxDocumentLabel')} <span className="text-danger">*</span></label>
                            <p className="font-[500] text-[13px] text-grey-950 my-[10px]">{t('profile.taxDocumentNote')}</p>
                            <div className="flex flex-wrap lg:flex-nowrap gap-x-[10px] gap-y-[10px] mb-[15px]">
                                <div className="w-full lg:w-[75%] text-grey-600 text-[16px] font-[500]"></div>
                                <div className="w-full lg:w-[25%] text-end">
                                    <div className={`inline-block text-[16px] font-[500] cursor-pointer select-none text-blue relative`}>
                                        <input type="file" id="file" name="file" accept=".pdf,.png,.jpg,.jpeg" ref={fileRef} onChange={handleChangeUpload} className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" />
                                        <span dir="lrt inline-block h-[24px] leading-[24px]">{t('profile.uploadFile')}</span>
                                        <span className="inline-block align-top w-[24px] h-[24px] ms-[5px]" style={{background:"url('/assets/images/export.svg')"}}></span>
                                    </div>
                                </div>
                            </div>
                            {uploadedFile && <div className="flex flex-wrap lg:flex-nowrap gap-x-[10px] gap-y-[10px] mb-[15px] mt-[-5px]">
                                <div className="text-[16px] font-[500] text-grey-600">
                                    <span className="inline-block align-middle w-[24px] h-[24px] me-[3px]" style={{background:"url('/assets/images/tick-circle.svg')"}}></span>
                                    {uploadedFile?.name}
                                    <span className="inline-block align-middle w-[24px] h-[24px] ms-[6px] cursor-pointer select-none" style={{background:"url('/assets/images/close-square.svg')"}} onClick={()=>setUploadedFile(null)}></span>
                                </div>
                            </div>}
                        </div>}


                        <div className="text-end">
                            <NormalButton label={t('profile.editButton')} onClick={handleClickTryUpdateVendor} isDisabled={isFormDisabled} />
                        </div>


                    </NormalFormContainer>

                    <div className="pb-[30px]"></div>
                </MainContent>
            </PageMain>
            {(!vendor || isLoading || !vendorForm) && <Loading showLoading={true} />}

            <Toast toast={toast} setToast={setToast} />
        </div>
    )
}

export default Profile;
